import React from "react";
import { Icon } from "antd";
import { getRandom } from "../../../theme/utils";

export const defaultHorizontalScroll = 1500;
export const defaultVerticalScroll = 400;
export const pageSizeLimitForMultiplePagination = 7;
export const paginationPosition ={
  both:"both",
  top:"top",
  bottom:"bottom"
};
export const defaultPagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  pageSize: 20,
  pageSizeOptions: ["5", "10", "20", "50"],
  hideOnSinglePage: true,
  position: paginationPosition.both
};
export const defaultColumnProps = {
  align: "center"
};
export const locale = {
  filterConfirm: "Tamam",
  filterReset: "Temizle",
  emptyText: "Aradığınız kriterlere uygun veri bulunamadı."
};
export const draggableColumn = {
  key: "drag-".concat(getRandom()),
  width: "10px",
  title: "",
  render: () => <Icon type="menu" />
};



// WEBPACK FOOTER //
// ./src/components/ui-ant/Datatable/constants.js